module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/mp4-793df778aceecd47f7076a2106036cb3.svg";